import React, { useState, VFC } from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  url: string;
}
const IframeComponent: VFC<Props> = ({ url }: Props) => {
  const [loaded, setLoaded] = useState(false);
  const loadCompleted = () => {
    setLoaded(true);
  };

  return (
    <IframeWrapper>
      {!loaded && <CircularProgress />}
      <Iframe src={url} onLoad={loadCompleted} loaded={loaded} />
    </IframeWrapper>
  );
};

export default IframeComponent;

const IframeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const Iframe = styled.iframe<{ loaded: boolean }>`
  display: ${({ loaded }) => (loaded ? 'block' : 'none')};
  width: 100%;
  height: 100%;
`;
